import { applyMembershipUnlockFromStatus } from '@core/translation/scheduler.ts';
import { t } from '../i18n/index.ts';
import type { StringKey } from '../i18n/strings.ts';

/** Derive membership unlock from stored statusJson (B-MEM-02). */
export function deriveUnlock(statusJson: string): boolean {
  if (!statusJson.trim()) return false;
  try {
    const next = applyMembershipUnlockFromStatus({ unlock: false }, statusJson);
    return next.unlock === true;
  } catch {
    return false;
  }
}

/** Normalized `/v2/auth/validate` status.response from statusJson. */
export function deriveStatusResponse(statusJson: string): string {
  if (!statusJson.trim()) return '';
  try {
    const parsed = JSON.parse(statusJson) as { response?: string };
    return typeof parsed.response === 'string' ? parsed.response : '';
  } catch {
    return '';
  }
}

/** i18n key for the user-facing membership status line. */
export function membershipStatusKey(statusJson: string, unlock: boolean): StringKey {
  if (unlock) return 'memberStatusActive';
  const response = deriveStatusResponse(statusJson);
  if (response === 'Session Expired') return 'memberStatusSessionExpired';
  if (response === 'Failed' || response === 'internal') return 'memberStatusCheckFailed';
  if (!response) return 'memberStatusSignedIn';
  return 'memberStatusInactive';
}

/** User-facing membership label for settings / login session. */
export function membershipStatusLabel(statusJson: string, unlock: boolean): string {
  return t(membershipStatusKey(statusJson, unlock));
}
